module.exports = __webpack_public_path__ + "img/samplea.0312e6e0.png";